import { connect } from 'react-redux';
import StatisticsSegments from './StatisticsSegments';

const StatisticsSegmentsComponent = connect(
    function mapStateToProps() {
        return {};
    },
    null
)(StatisticsSegments);

export default StatisticsSegmentsComponent;
